__turbopack_context__.v({
  "categoriesWrapper": "categories-module__ZANn_W__categoriesWrapper",
  "category": "categories-module__ZANn_W__category",
  "shevron": "categories-module__ZANn_W__shevron",
  "subcategory": "categories-module__ZANn_W__subcategory",
});
